import type { PageBlockDefinition } from '../definition-types'

export const storyRowDefinition: PageBlockDefinition = {
  type: 'story-row',
  label: 'Story Row',
  description: 'A row of 2–5 story cards with configurable column count and image aspect ratio.',
  rowCompatible: true,
  columnCompatible: false,
  category: 'editorial',
  minArticles: 2,
  maxArticles: 5,
  slots: [],
  defaultConfig: {
    columnCount: 3,
    imageAspectRatio: '4/3',
    sectionHeaderEnabled: false,
    sectionHeaderTitle: null,
    sectionHeaderStyle: 'rule-left',
    showImages: true,
    showSummary: false,
  },
  editorFields: [
    {
      key: 'columnCount',
      label: 'Columns',
      type: 'select',
      options: [
        { label: '2 Columns', value: '2' },
        { label: '3 Columns', value: '3' },
        { label: '4 Columns', value: '4' },
        { label: '5 Columns', value: '5' },
      ],
    },
    {
      key: 'imageAspectRatio',
      label: 'Image Aspect Ratio',
      type: 'select',
      options: [
        { label: '16:9 — Widescreen', value: '16/9' },
        { label: '4:3 — Standard', value: '4/3' },
        { label: '1:1 — Square', value: '1/1' },
        { label: '3:4 — Portrait', value: '3/4' },
      ],
    },
    { key: 'sectionHeaderEnabled', label: 'Show Section Header', type: 'toggle' },
    { key: 'sectionHeaderTitle', label: 'Section Header Title', type: 'text' },
    {
      key: 'sectionHeaderStyle',
      label: 'Section Header Style',
      type: 'select',
      options: [
        { label: 'Rule Left', value: 'rule-left' },
        { label: 'All Caps', value: 'all-caps' },
        { label: 'Plain', value: 'plain' },
      ],
    },
    { key: 'showImages', label: 'Show Images', type: 'toggle' },
    { key: 'showSummary', label: 'Show Summary', type: 'toggle' },
  ],
}
